import React from 'react';
import { createPortal } from 'react-dom';
import { Menu, Item, Separator } from 'react-contexify';
import { useTranslation } from 'react-i18next';
import { Copy, Download, FlipHorizontal2, FlipVertical2, Trash2 } from 'lucide-react';

import { useMediaStudio } from '../../context/MediaStudioContext';

import scss from './MediaStudioLayerContextMenu.module.scss';

export const MEDIA_STUDIO_LAYER_MENU_ID = 'media-studio/layer-context-menu';

const MenuIcon = ({ icon: Icon }) => <Icon size={16} strokeWidth={2} className={scss.icon} />;

const isEditableLayer = ({ props }) => Boolean(props?.layerId) && !props.locked;

const getLayerIds = (props) => props.layerIds || [props.layerId];

function MediaStudioLayerContextMenu() {
  const { t } = useTranslation('mediaStudio');
  const { editor, files, features } = useMediaStudio();

  return createPortal(
    <Menu id={MEDIA_STUDIO_LAYER_MENU_ID} animation='fade' className={scss.menu}>
      <Item
        disabled={(params) => !isEditableLayer(params)}
        onClick={({ props }) => editor.flipHorizontal(getLayerIds(props))}>
        <span className={scss.item}>
          <MenuIcon icon={FlipHorizontal2} />
          {t('flipH')}
        </span>
      </Item>
      <Item
        disabled={(params) => !isEditableLayer(params)}
        onClick={({ props }) => editor.flipVertical(getLayerIds(props))}>
        <span className={scss.item}>
          <MenuIcon icon={FlipVertical2} />
          {t('flipV')}
        </span>
      </Item>
      {features.duplicate ? (
        <Item
          disabled={(params) => !isEditableLayer(params)}
          onClick={({ props }) => editor.duplicateElements(getLayerIds(props))}>
          <span className={scss.item}>
            <MenuIcon icon={Copy} />
            {t('duplicate')}
          </span>
        </Item>
      ) : null}
      <Separator />
      <Item onClick={files.download}>
        <span className={scss.item}>
          <MenuIcon icon={Download} />
          {t('download')}
        </span>
      </Item>
      <Item
        disabled={(params) => !isEditableLayer(params)}
        onClick={({ props }) => editor.deleteElements(getLayerIds(props))}>
        <span className={scss.item}>
          <MenuIcon icon={Trash2} />
          {t('remove')}
        </span>
      </Item>
    </Menu>,
    document.body,
  );
}

export default MediaStudioLayerContextMenu;
